export default "__VITE_ASSET__COpECTSP__"